<div id="system-info-tabs-div" class="tab-content device-info-container" fill *ngIf="!!display && !!device">
    <div class="tab-pane active in system-info-tab-pane" id="systeminfo">
        <div>
            <div class="panel panel-default">
                <div class = "panel-heading">
                    <h4 class="sysinfo-h4">{{'deviceInfo_DeviceDetails_Caption' | xsI18n}}</h4>
                </div>
                <div class="panel-body">
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-devicename-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_DeviceName_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.deviceName)}}</div>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-phonenumber-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_PhoneNumber_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.phoneNumber)}}</div>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-platform-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_Platform_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.platform)}}</div>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-osversion-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_OSVersion_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.osVersion)}}</div>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-username-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_User_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.userName)}}</div>
                    </div>
                     <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-userPhoneNumber-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_UserPhoneNumber_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.userPhoneNumber)}}</div>
                    </div>

                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-manufacturer-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_Manufacturer_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.manufacturer)}}</div>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-model-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_Model_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.model)}}</div>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-serialnumber-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_SerialNumber_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.hardwareSerialNumber)}}</div>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-macaddress-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_MACAddress_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.macAddress)}}</div>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-imei-section-div">
                        <div class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_IMEI_Caption' | xsI18n}}</div>

                        <div class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(device.imei)}}</div>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-width-section-div">
                        <span class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_Width_Caption' | xsI18n}}</span>

                        <span class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{'deviceInfo_Pixels_Format' | xsI18n : display.width}}</span>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-height-section-div">
                        <span class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_Height_Caption' | xsI18n}}</span>

                        <span class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{'deviceInfo_Pixels_Format' | xsI18n : display.height}}</span>
                    </div>
                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-bitdepth-section-div">
                        <span class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_BitDepth_Caption' | xsI18n}}</span>

                        <span class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{'deviceInfo_Bit_Format' | xsI18n : display.depth}}</span>
                    </div>

                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-totalMemory-section-div">
                        <span class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_TotalMemory_Caption' | xsI18n}}</span>

                        <span class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{physicalMemory.used + " / " + physicalMemory.total}}</span>
                    </div>

                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-virtualMem-section-div">
                        <span class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_VirtualMemory_Caption' | xsI18n}}</span>

                        <span class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(virtualMemory.used)}}</span>
                    </div>

                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-sysStorage-section-div">
                        <span class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_SystemStorage_Caption' | xsI18n}}</span>

                        <span class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{storage.used + " / " + storage.total}}</span>
                    </div>

                    <div class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-internalStorage-section-div">
                        <span class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_InternalStorage_Caption' | xsI18n}}</span>

                        <span class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{getProperDisplayValue(virtualMemory.used)}}</span>
                    </div>

                    <div *ngIf="battery" class="display-table no-gutter fill sysinfo-info-subsection-divider" id="sysinfo-battery-section-div">
                        <span class="display-table-cell condensed sysinfo-overflow">{{'deviceInfo_MainBatteryStatus_Caption' | xsI18n}}</span>

                        <span class="display-table-cell condensed sysinfo-info-value sysinfo-overflow">{{battery.value}}%</span>
                    </div>
                </div>
        </div>
    </div>
</div>
